import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from '../img/tramites.png';
import { isAuth } from '../utils/auth';
import './NavBar.css';

const NavBar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkAuth = async () => {
            const auth = await isAuth();
            setIsAuthenticated(auth);
        };
        checkAuth();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        navigate('/login');
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    return ( 
        <nav className="navbar-modern">
            <div className="navbar-container">
                <Link to="/panel-admin" className="navbar-brand">
                    <img src={logo} alt="Tramites Pronto" className="navbar-logo" />
                    <span className="navbar-brand-text">Tramites Pronto</span>
                </Link>

                <button 
                    className={`navbar-toggle ${isMenuOpen ? 'active' : ''}`}
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="Toggle menu"
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>

                <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
                    <Link 
                        to="/panel-admin" 
                        className={`navbar-link ${isActive('/panel-admin') ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <i className="fa-solid fa-list"></i>
                        <span>Facturas</span>
                    </Link>
                    <Link 
                        to="/panel-admin/crear" 
                        className={`navbar-link ${isActive('/panel-admin/crear') ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <i className="fa-solid fa-plus"></i>
                        <span>Nueva Factura</span>
                    </Link>
                    <Link 
                        to="/panel-admin/editar-landing" 
                        className={`navbar-link ${isActive('/panel-admin/editar-landing') ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <i className="fa-solid fa-pen-to-square"></i>
                        <span>Editar Landing</span>
                    </Link>
                    <Link
                        to="/panel-admin/qr"
                        className={`navbar-link ${isActive('/panel-admin/qr') ? 'active' : ''}`}
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <i className="fa-solid fa-qrcode"></i>
                        <span>Código QR</span>
                    </Link>
                    <div className="navbar-divider"></div>
                    <a 
                        href={window.location.origin} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="navbar-link" 
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <i className="fa-solid fa-globe"></i>
                        <span>Ir a la web</span>
                    </a>
                    {isAuthenticated && (
                        <button 
                            className="navbar-link navbar-logout"
                            onClick={handleLogout}
                        >
                            <i className="fa-solid fa-sign-out-alt"></i>
                            <span>Cerrar Sesión</span>
                        </button>
                    )}
                </div>
                </div>
            </nav>
    );
}

export default NavBar;
